// 82ZONE product details column (sections/product-information.liquid): sticky at the top on desktop.
// When it grows taller than the viewport (an open size guide, long details), it sticks by its bottom edge
// instead, so its lower part and the buy button stay reachable while the gallery scrolls.
const SELECTOR = '.product-information__grid .product-details';
const BOTTOM_GAP = 24;

/** @type {WeakSet<Element>} */
const tracked = new WeakSet();
/** @type {WeakMap<Element, number>} */
const topOffsets = new WeakMap();

/**
 * @param {Element} element
 */
const update = (element) => {
  if (!(element instanceof HTMLElement)) return;
  const styles = getComputedStyle(element);
  let top = '';

  if (styles.position === 'sticky') {
    // The stylesheet offset can only be read while no inline top overrides it.
    if (!element.style.top) topOffsets.set(element, parseFloat(styles.top) || 0);
    const offset = topOffsets.get(element) ?? 0;
    const height = element.getBoundingClientRect().height;
    if (offset + height + BOTTOM_GAP > window.innerHeight) {
      top = `${Math.round(window.innerHeight - height - BOTTOM_GAP)}px`;
    }
  }

  if (element.style.top !== top) element.style.top = top;
};

const resizeObserver = new ResizeObserver((entries) => entries.forEach((entry) => update(entry.target)));
// A morph of <main> restores the server style attribute; put the anchor back.
const styleObserver = new MutationObserver((records) => records.forEach((record) => update(record.target)));

const init = () => {
  document.querySelectorAll(SELECTOR).forEach((element) => {
    if (tracked.has(element)) {
      update(element);
      return;
    }
    tracked.add(element);
    resizeObserver.observe(element);
    styleObserver.observe(element, { attributes: true, attributeFilter: ['style'] });
    update(element);
  });
};

window.addEventListener('resize', () => document.querySelectorAll(SELECTOR).forEach(update), { passive: true });
document.addEventListener('shopify:section:load', init);
init();
